<div class="tw-py-[15px] tw-px-6 tw-bg-teal-100 tw-shadow-z13" (click)="changeAddress.emit()">
  <div class="tw-flex tw-items-center tw-justify-between">
    <p class="tw-font-body tw-text-300 tw-font-normal tw-text-gray-800 tw-m-0">
      <span i18n="@@deliveringTo">Delivering to:</span><span class="tw-font-bold"> {{ address()?.city }}</span>
    </p>
    <p class="tw-text-200 tw-font-lexend tw-font-semibold tw-text-teal-600 tw-m-0" i18n="@@change">Change</p>
  </div>
  <div class="tw-max-w-[70%]">
    <p class="tw-font-body tw-font-medium tw-text-200 tw-text-gray-500 tw-truncate tw-capitalize tw-m-0">{{ formattedAddress() }}</p>
  </div>
</div>
